import { Stack, Typography } from '@mui/material';

const WelcomeStep = () => {
  return (
    <Stack spacing={3} direction="column">
      <Typography
        variant="h5"
        component="p"
        textAlign="center"
        sx={{
          fontSize: {
            xs: 18,
          },
        }}
      >
      
      </Typography>
    </Stack>
  );
};

export default WelcomeStep;
